import { h } from 'preact'
import { Text } from 'preact-i18n'
import FadingImage from './FadingImage'

export default ({options = [], selected, onChange = () => {}, color}) =>
    <div class="limba__mount-options">
        <div class="row">
            {options.map(option =>
                <div class="col-md-4">
                    <div class={"limba__mount-options--option " + (selected == option ? 'selected' : '')} onClick={() => onChange(option)}>
                        <div class="mo-label">
                            <Text id={"mountTypes." + option.label} />
                        </div>
                        <div class="img-wrap">
                            <FadingImage src={`images/deckenanbindung/${option.name}-${color.name}.png`} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    </div>


// WEBPACK FOOTER //
// ./js/components/MountOptions.js